import * as x from "yup";
import { Q as y } from "./profileApi-04b19141.mjs";
import { i as N } from "./ContactType-95758036.mjs";
import { a as G, o as B } from "./Utils-116ac93f.mjs";
import { useTranslation as U } from "@nextgen-web-framework/all";
import { MyAccountFieldType as I, MyAccountExtEnum as A, MyAccountFieldName as O } from "./utils/types/enum.js";
import { b as E, u as _, d as D, m as q, f as Y, r as b, v as j } from "./helper-bed9746b.mjs";
import { useMyAccountAddressConfig as H, useCountryMasterData as k } from "./utils/masterdata.js";
import { ADDRESS_FIELDS as F } from "./utils/Constants.js";
const X = {
  NonLegalEntity: "NON_LEGAL_ENTITY",
  LegalEntity: "LEGAL_ENTITY"
}, z = (t, n = N.Billing) => {
  const e = t, s = e.find((r) => r.pk === n);
  return s || (e.find((r) => r.pk === N.Billing) ?? {
    pk: N.Billing,
    inputs: [],
    ext: []
  });
}, ge = (t, n, e, s = !1, r) => {
  if (r)
    return t(r);
  {
    const a = s ? "" : `.${e.toLowerCase()}`;
    return t(`profile.AddressInput${a}.${n}`);
  }
}, Ee = (t) => {
  const { fieldName: n, fieldType: e, visible: s, ext: r } = t;
  return s ? e || (S(A.DROPDOWN_DATASOURCE, r) === "api" ? I.GUIDED_INPUT : ["phone", "receipientMobile"].includes(n) ? I.PHONE : I.TEXT) : I.NONE;
}, ye = (t, n, e) => n ? {
  ...n,
  contactType: N.Billing,
  version: (e == null ? void 0 : e.version) ?? 0,
  contactId: e == null ? void 0 : e.contactId
} : e ?? t, K = (t, n, e, s = N.Billing) => n ? {
  ...n,
  contactType: s,
  version: (e == null ? void 0 : e.version) ?? 0,
  contactId: e == null ? void 0 : e.contactId
} : e ?? t, Ie = (t, n = !1) => n ? t.filter((e) => e.editable && e.visible && e.validations && e.validations.required === !0).map((e) => e.fieldName) : t.filter((e) => e.editable && e.visible).map((e) => e.fieldName), R = (t, n) => n.every((e) => (t == null ? void 0 : t[e]) !== void 0 && (t == null ? void 0 : t[e]) !== "") && // This is to check the frontend validation for entire address, so it will block the submit button if it's invalid
((t == null ? void 0 : t.feValidation) === void 0 || (t == null ? void 0 : t.feValidation) === !0), Te = (t, n, e = []) => !e.every((s) => (t == null ? void 0 : t[s]) === (n == null ? void 0 : n[s])), W = (t, n) => {
  const e = n.find((s) => s.pk === t);
  return (e == null ? void 0 : e.countryName) ?? t;
}, Ae = (t, n) => {
  const e = n.find((s) => s.value === t);
  return (e == null ? void 0 : e.name) ?? t;
}, he = (t, n = !1) => {
  var c, l;
  const e = H(), s = U(), { allData: r, currentCountry: a } = k(), i = E((c = a == null ? void 0 : a.pk) == null ? void 0 : c.toUpperCase());
  try {
    const f = [], o = {
      ...t
    }, { inputs: T, ext: p } = z(e, t == null ? void 0 : t.contactType), u = S(A.ADDRESS_FORMAT, p);
    if (o != null && o.countryCode && (u != null && u.includes(F.COUNTRY_CODE)) && (o.countryCode = W(o.countryCode, r)), S(A.GUIDED_INPUT, p) && (o != null && o.state) && (u != null && u.includes(F.STATE)) && (o.state = _(s, `profile.AddressInput.state.${i}.`, o.state)), (l = T.filter((m) => m == null ? void 0 : m.options)) == null || l.map((m) => {
      const { fieldName: d, options: g } = m;
      (g == null ? void 0 : g.find((P) => P.key === o[d])) && (o[d] = _(s, `profile.AddressInput.${d}.`, o[d]));
    }), typeof u == "string") {
      let m = u;
      return n && (m = m.replace(/<\/?[a-z][\s\S]*?>/gi, "")), T == null || T.forEach((d) => {
        const g = (o == null ? void 0 : o[d.fieldName]) || "";
        m = m.replace(`{${d.fieldName}}`, g);
      }), m.replace(/,\s*,/g, ", ").replace(/,\s*$/, "").replace(/\s\s+/g, " ").trim();
    } else {
      const m = u;
      return m == null || m.forEach((d) => {
        var g;
        (g = o == null ? void 0 : o[d]) != null && g.trim() && f.push(o[d]);
      }), f.join(", ");
    }
  } catch {
    return "";
  }
}, Se = async (t, n = D) => {
  const e = t == null ? void 0 : t.contactId;
  return t.isDefault = !0, e ? await n(() => y.putProfileAddress({ contactId: e, payload: t })) : await n(() => y.postProfileAddress({ payload: t }));
}, Ce = async (t, n = D) => {
  const { payload: e, ownerProfileId: s, originalAddress: r, isEdit: a, callback: i, successMessage: c, failedMessage: l } = t;
  if (!s) {
    i == null || i({ ...e, isSaved: !1 });
    return;
  }
  let f;
  try {
    delete e.sourceApplication;
    const o = a ? await n(
      () => y.putShippingAddressList({ payload: e, contactId: (r == null ? void 0 : r.contactId) ?? "" })
    ) : await n(() => y.createShippingDetails({ payload: e }));
    c == null || c(), f = {
      ...o,
      isSaved: !0
    };
  } catch {
    l == null || l(), f = {
      ...e,
      isErrorOnSave: !0,
      isSaved: !1
    };
  }
  i == null || i(f);
}, Pe = (t, n) => {
  const e = t, s = n == null ? void 0 : n.find(
    (r) => r.ownerId === (t == null ? void 0 : t.ownerId)
  );
  return e && (s != null && s.ownerId) && !e.profileName && (e.profileName = `${s.firstName} ${s.lastName}`), e;
}, De = (t, n) => {
  const { contactNickname: e, recipientFirstName: s, recipientLastName: r } = t;
  return e || (s || r ? `${n("profile.AddressInput.addressName", { firstName: s, lastName: r })}` : `${n("profile.AddressInput.address")}`);
}, _e = async (t, n = D) => {
  var e, s, r;
  try {
    const a = await n(() => y.getProfileAddress({ ownerId: t, isDefault: !0 })), i = ((e = a.contacts) == null ? void 0 : e.find((f) => f.contactType === N.Mailing)) ?? {
      contactType: N.Mailing
    }, c = ((s = a.contacts) == null ? void 0 : s.find((f) => f.contactType === N.Billing)) ?? {
      contactType: N.Billing
    }, l = ((r = a.contacts) == null ? void 0 : r.find((f) => f.contactType === N.Tax)) ?? null;
    return {
      mailingAddress: i,
      billingAddress: c,
      taxAddress: l ?? i
    };
  } catch {
    return {
      mailingAddress: { contactType: N.Mailing },
      billingAddress: { contactType: N.Billing },
      taxAddress: { contactType: N.Tax }
    };
  }
}, xe = (t, n, e, s) => {
  s((r) => {
    const a = r.map(
      (c) => c.fieldName === t ? { ...c, searchKeyword: n, data: e } : c
    );
    return a.some((c) => c.fieldName === t) || a.push({
      fieldName: t,
      searchKeyword: n,
      data: e
    }), a;
  });
}, J = async (t, n, e) => {
  const s = t.find(
    (r) => {
      var a;
      return (a = r.ext) == null ? void 0 : a.some((i) => i.key === A.DEPENDENCY && i.value === n);
    }
  );
  s != null && s.fieldName && (await e.setFieldValue(s.fieldName, "", !1), await e.setFieldTouched(s.fieldName, !1, !1), e.setFieldError(s.fieldName, ""), await J(t, s.fieldName, e));
}, Q = {
  STEP_REGISTRATION_PROFILE: "personalInfoStep",
  STEP_PROFILE_FORM: "personalInfoForm",
  STEP_CO_APP_FORM: "coAppConfig",
  STEP_MY_BUSINESS_FORM: "businessInformationConfig",
  STEP_GENERAL_CONFIG: "generalConfig",
  // To remove after phone number is updated
  STEP_ACCOUNT_LIFE_CYCLE: "accountLifeCycleConfig",
  STEP_ADDRESS_BILLING: N.Billing,
  STEP_ADDRESS_MAILING: N.Mailing,
  STEP_ADDRESS_SHIPPING: N.Shipping
}, Oe = {
  PERSONAL_INFORMATION: "profileInformation",
  CO_APP: "accountInformation",
  MY_BUSINESS: "profileInformation"
}, Z = {
  PROFILE_SECTION_ADDRESS: "address",
  PROFILE_SECTION_INFO: "information",
  PROFILE_SECTION_CONTACT: "contact",
  PROFILE_SECTION_TAX: "tax"
}, be = (t) => (t == null ? void 0 : t.find((n) => n.pk === Q.STEP_PROFILE_FORM)) ?? {
  inputs: [],
  ext: []
}, Fe = (t, n) => (t == null ? void 0 : t.find((e) => e.pk === n)) ?? {
  pk: "",
  inputs: [],
  ext: []
}, Re = (t, n) => t.find(
  (e) => e.fieldName === n && (!Array.isArray(e == null ? void 0 : e.env) || Array.isArray(e == null ? void 0 : e.env) && e.env.includes(q()))
) ?? {
  fieldName: n,
  value: null,
  visible: !1
}, Me = (t) => t.replace(/\w\S*/g, (n) => n.charAt(0).toUpperCase() + n.substring(1).toLowerCase()), Ve = (t, n) => t ? n : "", Le = (t, n, e) => t || e || n, we = (t) => {
  const { fieldName: n, fieldType: e, visible: s, options: r } = t;
  return s ? e || (["titleSalutation", "gender", "maritalStatus", "citizenship"].includes(n) && r ? I.DROPDOWN : ["birthDate", "joinDate", "expiryDate"].includes(n) ? I.DATE : ["profilePic"].includes(n) ? I.PICTURE : I.TEXT) : I.NONE;
}, $e = (t, n, e) => t.map((s) => ({
  key: s.key,
  value: s.value,
  label: n(`profile.ProfileInfo.${e}.${s.key}`)
})), ve = (t, n, e, s, r) => {
  var c;
  const a = (e && ((c = s == null ? void 0 : s.find((l) => l.value === e)) == null ? void 0 : c.key)) ?? e, i = r ? `${r}.` : "";
  return _(t, `profile.ProfileInfo.${n}.${i}`, a);
}, Ge = (t, n, e = 0, s, r, a) => {
  const i = `${t["date-picker"]}`;
  if (n) {
    const l = Y(n, s, r), f = new Date(n), o = a ? "" : t["gray-border"];
    return {
      birthDate: f,
      formattedDate: l,
      value: f,
      classNames: `${i} ${t["date-picker-filled"]} ${o}`
    };
  }
  const c = /* @__PURE__ */ new Date();
  return c.setFullYear(e), {
    formattedDate: "",
    birthDate: c,
    classNames: i
  };
}, M = (t) => {
  const n = /\d+/g, e = t == null ? void 0 : t.match(n);
  return e ? e.join("") : "";
}, Be = async (t) => {
  var n, e;
  try {
    const {
      schema: s,
      addrSectionConfig: r,
      profileInfo: a,
      phoneVerified: i,
      emailVerified: c,
      originalProfile: l,
      addrMandatoryFields: f,
      isEmailRequired: o
    } = t, { mailingAddress: T, billingAddress: p, useAsBilling: u, profileData: h } = a, m = await s.validate(a.profileData), d = ((n = r == null ? void 0 : r.find((P) => P.fieldName === "mailingAddress")) == null ? void 0 : n.editable) ?? !1, g = ((e = r == null ? void 0 : r.find((P) => P.fieldName === "useAsBilling")) == null ? void 0 : e.visible) ?? !1;
    return !!(m && // Address validation: if mailing address is enabled, then perform the validation
    (d && R(T, f) || !d) && (g && (u || R(p, f)) || !g) && // pass if no change or is verified
    (b(E(h.phone)) === b(E(l.phone)) && M(h.dialCode) === M(l.dialCode) || i) && (h.email === l.email || c || !o && !h.email));
  } catch {
    return !1;
  }
}, w = (t) => {
  const n = /* @__PURE__ */ new Date();
  let e = n.getFullYear() - t.getFullYear();
  const s = n.getMonth() - t.getMonth();
  return (s < 0 || s === 0 && n.getDate() < t.getDate()) && e--, e;
}, C = (t, n, e) => e ? `${e}.${n}` : `profile.validationMsg.${t}.${n}`, Ue = (t) => {
  var e;
  const n = {};
  return (e = t == null ? void 0 : t.filter((s) => (s == null ? void 0 : s.visible) && (s == null ? void 0 : s.validations) && (s == null ? void 0 : s.editable))) == null || e.forEach((s) => {
    const { fieldName: r, validations: a } = s || {}, { required: i } = a || {}, { ext: c } = s, l = S(A.CUSTOM_LABEL_KEY, c), f = S(A.USE_REGEX_VALIDATION, c) ?? !1;
    let o = x.string();
    i ? o = ee(s, o, l) : o.nullable(), r !== O.PHONE ? (o = V(s, o, l), o = se(s, o), o = ne(s, o), o = re(s, o, l), o = ae(s, o, l)) : r === O.PHONE && f ? o = V(s, o, l) : o = o.matches(j, C(r, "format", l)), n[r] = o;
  }), x.object().shape(n);
}, ee = (t, n, e) => {
  const { fieldName: s, ext: r } = t, a = S(A.VISIBLE_IF, r);
  if (a) {
    const { targetFieldName: i, targetFieldValue: c } = a;
    return n.when(i, {
      is: (l) => l === c,
      then: (l) => l.required(C(i, "required", e)),
      otherwise: (l) => l.nullable()
    });
  } else
    return n.required(C(s, "required", e));
}, V = (t, n, e) => {
  const { fieldName: s, validations: r } = t, { regex: a } = r || {};
  return a ? n.test({
    name: "regex",
    message: C(s, "format", e),
    test: (i) => i ? new RegExp(a, "giu").test(i) : !0
  }) : n;
}, te = (t, n) => {
  if (!n)
    return t;
  const e = new RegExp(n, "gu");
  return t.replace(e, "");
}, $ = (t, n) => {
  const { ext: e } = t, s = S(A.EXCLUDE_CHARS, e);
  return s ? te(E(n), s) : E(n);
}, se = (t, n) => {
  const { validations: e } = t;
  if (!(e != null && e.min))
    return n;
  const s = e == null ? void 0 : e.min;
  return n.test({
    name: "minLength",
    message: "profile.validationMsg.string.min",
    test: (r) => r ? $(t, r).length >= s : !0
  });
}, ne = (t, n) => {
  const { validations: e } = t;
  if (!(e != null && e.max))
    return n;
  const s = e == null ? void 0 : e.max;
  return n.test({
    name: "maxLength",
    message: "profile.validationMsg.string.max",
    test: (r) => r ? $(t, r).length <= s : !0
  });
}, re = (t, n, e) => {
  const { validations: s } = t;
  if (!(s != null && s.minAge))
    return n;
  const r = s == null ? void 0 : s.minAge;
  return n.test({
    name: "minAge",
    message: C(t.fieldName, "min", e),
    test: (a) => {
      const i = new Date(a ?? "");
      return w(i) >= r;
    }
  });
}, ae = (t, n, e) => {
  const { validations: s } = t;
  if (!(s != null && s.maxAge))
    return n;
  const r = s == null ? void 0 : s.maxAge;
  return n.test({
    name: "maxAge",
    message: C(t.fieldName, "max", e),
    test: (a) => {
      const i = new Date(a ?? "");
      return w(i) <= r;
    }
  });
}, S = (t, n, e) => {
  var s;
  return ((s = n == null ? void 0 : n.find(
    (r) => (r == null ? void 0 : r.key) === t && (!e || !r.env || Array.isArray(r.env) && r.env.includes(e))
  )) == null ? void 0 : s.value) ?? null;
}, qe = (t, n) => {
  const {
    addr: e,
    contactTypeToFieldName: s,
    contactTypeCombination: r,
    profileInfo: a,
    useAsMailingConfig: i,
    useAsBillingConfig: c,
    accountNum: l
  } = t, { setProfileInfo: f, setIsProfileChanged: o } = n, T = s[e.contactType];
  e.updated = !0;
  const p = {
    ...a,
    [T]: e
  };
  let u = null;
  if (c != null && c.visible && p.useAsBilling ? u = N.Billing : i != null && i.visible && p.useAsMailing && (u = N.Mailing), u) {
    const h = s[u], [m, d] = r[u], g = G(u, l, B.Account);
    p[h] = K(
      g,
      p == null ? void 0 : p[m],
      p == null ? void 0 : p[d],
      u
    );
  }
  f(p), o(!0);
}, ie = (t, n) => {
  const e = [];
  return t.forEach((s) => {
    var r;
    s.section === n && ((r = s == null ? void 0 : s.inputs) == null || r.forEach((a) => {
      a.editable && e.push(a.fieldName);
    }));
  }), e;
}, oe = (t) => t.displayName ? t : {
  ...t,
  displayName: {}
};
function Ye(t, n, e) {
  let s = {};
  (s == null ? void 0 : s.partyId) === 0 && delete s.partyId;
  const r = ie(e, Z.PROFILE_SECTION_INFO), a = {
    firstName: "givenName",
    lastName: "familyName",
    titleSalutation: "prefix"
  };
  return r.forEach((i) => {
    if (["firstName", "lastName", "titleSalutation"].includes(i) && a[i] && t[i] !== n[i])
      s = oe(s), s.displayName[a[i]] = t[i];
    else if (i === "birthDate") {
      const c = new Date(E(t.birthDate)), l = new Date(E(n.birthDate));
      c.setHours(0, 0, 0, 0), l == null || l.setHours(0, 0, 0, 0), isNaN(c.getTime()) || c.getTime() !== l.getTime() && (s.birthDate = c);
    } else
      t[i] !== n[i] && (s[i] = t[i]);
  }), s;
}
const L = (t, n) => {
  for (const e of t)
    if (e.taxable === n)
      return {
        recordNumber: E(e.recordNumber),
        recordType: E(e.recordType)
      };
  return { recordNumber: "", recordType: "" };
}, je = (t, n) => {
  var c, l;
  let e = "", s = "", r = "";
  const a = t ?? [], { recordNumber: i } = L(a, !0);
  if (e = i, n && ((c = n == null ? void 0 : n.legalEntity) == null ? void 0 : c.type) === X.LegalEntity && (e = E((l = n == null ? void 0 : n.legalEntity) == null ? void 0 : l.taxId, e)), (t == null ? void 0 : t.length) === 1) {
    const [f] = t;
    s = E(f.recordNumber), r = E(f.recordType);
  } else {
    const { recordNumber: f, recordType: o } = L(a, !1);
    s = f, r = o;
  }
  return { taxId: e, idNumber: s, documentType: r };
}, He = async (t, n = !1, e = D) => {
  const { phoneId: s } = t;
  return n ? s ? await e(() => y.deleteAccountPhone(s)) : t : s ? await e(() => y.patchAccountPhone(s, t)) : await e(() => y.postAccountPhone(t));
}, ke = async (t, n = !1, e = D) => {
  const { emailId: s } = t;
  return n ? s ? await e(() => y.deleteAccountEmail(s)) : t : s ? await e(() => y.patchAccountEmail(s, t)) : await e(() => y.postAccountEmail(t));
};
export {
  Ee as A,
  ge as B,
  te as C,
  J as D,
  xe as E,
  Re as F,
  ye as G,
  R as H,
  W as I,
  Ae as J,
  be as K,
  C as L,
  Q as M,
  ie as N,
  L as O,
  Z as P,
  Oe as S,
  S as a,
  ve as b,
  Ve as c,
  Ie as d,
  z as e,
  we as f,
  Fe as g,
  Be as h,
  Te as i,
  Le as j,
  Ge as k,
  $e as l,
  K as m,
  qe as n,
  Pe as o,
  Ue as p,
  De as q,
  je as r,
  _e as s,
  Me as t,
  he as u,
  Se as v,
  Ye as w,
  He as x,
  ke as y,
  Ce as z
};
//# sourceMappingURL=myAccountProfileUtils-f5c6715f.mjs.map
